export const ASSETS_PATH = "/static";
export const TEHRAN_CENTER: [number, number] = [51.2075701, 35.7077714];
export const LISTING_PER_PAGE = 10;
export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoicm95YXJlemFlZTMiLCJhIjoiY2t6Y3BlY2dpMGV0NTJ3cHl4N3JnMG5kdyJ9.qcXM0Qy10sTLF4cVePwqbQ";
export const DEBUG_MODE = false;
